package com.appsyde.shared.modules.ticket.domain.model

sealed class AcquireLockResult {
    data class Success(val writeLock: WriteLockDetail) : AcquireLockResult()
    data class LockedByOther(val lockedByAccountUserId: String, val lockedByDisplayName: String, val expiresAt: kotlinx.datetime.Instant) : AcquireLockResult()
    data object NotAssignee : AcquireLockResult()
    data object NotOwnedOrExpired : AcquireLockResult()
}

sealed class RenewLockResult {
    data class Success(val expiresAt: kotlinx.datetime.Instant) : RenewLockResult()
    data object NotOwnedOrExpired : RenewLockResult()
}
